import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'prolift.calendar.view';
const VALID_VIEWS = ['week', 'month'];
const DEFAULT_VIEW = 'week';

const readStoredView = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return VALID_VIEWS.includes(stored) ? stored : DEFAULT_VIEW;
  } catch {
    return DEFAULT_VIEW;
  }
};

export const useCalendarView = () => {
  const [view, setView] = useState(readStoredView);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, view);
    } catch {
      /* silent */
    }
  }, [view]);

  const changeView = useCallback((next) => {
    if (VALID_VIEWS.includes(next)) setView(next);
  }, []);

  return { view, setView: changeView };
};
